import Vue from 'vue'
import Vuex from 'vuex'
import logger from 'vuex/dist/logger';
import {notify} from './modules/notify';
import {users} from './modules/users';
import {lang} from './modules/lang';
import {authentification } from './modules/auth';

const debug = process.env.NODE_ENV !== 'prod';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: debug,
  modules: { notify, users, authentification, lang  },
  plugins: debug ? [logger()] : [],
})
